export const SOFTLINE_API_PMS_STATUSABFRAGE_ABTEILUNGEN_MITARBEITER = 'v1/statusabfrage/personaluebersicht/{{stichdatum}}/entities';
export const SOFTLINE_API_PMS_STATUSABFRAGE_ABTEILUNGEN_MITARBEITER_DETAIL = 'v1/statusabfrage/personaluebersicht/{{stichdatum}}/detail/{{idlstfix}}';

export const SOFTLINE_API_PMS_STATUSABFRAGE_ABTEILUNGEN = 'v1/statusabfrage/abteilung/{{stichdatum}}/entities';